
import {
  Component,
  Vue,
  Prop,
  Model,
  Emit,
  Watch
} from "vue-property-decorator";
import ModalHeader from "@/components/modal-header.vue";
import CandidateCreateForm, {
  JobCreateForm,
  StructParam
} from "@/lib/form/candidate/CandidateCreateForm";
import Candidate, { CandidateGet } from "@/lib/model/exam/candidate";
import ModalTitle from "@/lib/model/exam/modal-title";
import CandidateListForm from "@/lib/form/candidate/CandidateListForm";
import CandidateRepeatCreateForm from "@/lib/form/candidate/CandidateRepeatCreateForm";
import _ from "lodash-es";
import Job from "@/lib/job/job";

@Component({
  components: {}
})
export default class AddOneCandidateModal extends Vue {
  @Prop({}) jobId!: number;
  jobCreateForm = new JobCreateForm();

  created() {
    //
  }
  mounted() {
    this.jobCreateForm.jobId = this.jobId;
  }

  addSubmit() {
    Job.createWhite(this.jobCreateForm).then(res => {
      if (res) {
        this.$message.success("添加成功");
        this.$emit("success");
      }
    });
  }

  addSubmitContinue() {
    Job.createWhite(this.jobCreateForm).then(res => {
      if (res) {
        this.$message.success("添加成功");
        this.jobCreateForm = new JobCreateForm();
        this.jobCreateForm.jobId = this.jobId;
        this.$emit("f5");
      }
    });
  }
  cancel() {
    this.$emit("cancel");
  }
}
